import { INIT_ANIO_GUARDADO, SET_ANIO_GUARDADO, SET_ESTRUCTURA_GUARDADO, SET_TIPO_GUARDADO } from "../../types/objetivos/anioGuardadoTypes";

export const setInitAnioGuardado = () => ({ type: INIT_ANIO_GUARDADO });

export const setAnioGuardado = (prop:string, datasave: any) => ({ type: SET_ANIO_GUARDADO, payload: {prop, datasave} });

export const setEstructuraGuardado = (prop:string, datasave: any) => ({ type: SET_ESTRUCTURA_GUARDADO, payload: {prop, datasave} });

export const setTipoGuardado = (prop:string, datasave: any) => ({ type: SET_TIPO_GUARDADO, payload: {prop, datasave} });